<template>
  <div class="container">
    <div class="header">
      <div>
        <el-menu
          :default-active="currentPath"
          @select="handleSelect"
          class="el-menu-demo"
          mode="horizontal"
          background-color="#fff"
          text-color="#000000"
          active-text-color="#00a0e9"
        >
          <div class="logo">
            <div class="index_logo">
              <img src="@/assets/index_logo_white.png" />
            </div>
          </div>
          <el-menu-item index="/home">首页</el-menu-item>
          <el-submenu index="/oreder">
            <template slot="title">订单中心</template>
            <el-menu-item index="/order/boothOrder">展位订单</el-menu-item>
            <el-menu-item index="/order/leaseOrder/utilities">水电气租赁订单</el-menu-item>
            <el-menu-item index="/order/leaseOrder/equipment">展具租赁订单</el-menu-item>
            <el-menu-item index="/order/leaseOrder/overtimepay">加班费订单</el-menu-item>
            <!-- <el-menu-item index="2-3">加班申请订单</el-menu-item> -->
          </el-submenu>
          <el-menu-item index="/help">帮助中心</el-menu-item>
          <el-menu-item index="/mbr">个人中心 </el-menu-item>
          <mbr-info></mbr-info>
        </el-menu>
      </div>
    </div>
    <div class="nav-page">
      <router-view />
    </div>

    <div class="wrapper-back">
      <div class="bottom-wrapper">
        <div class="copy-text">
          <label> Copyright © {{ proconfig.icp }} </label>
          <br />
          <label style="margin-top: 15px; display: inline-block">
            <a target="_blank" href="https://beian.miit.gov.cn/">{{ proconfig.beian }}</a>
          </label>
          <br />
          <label style="margin-top: 15px; display: inline-block">
            {{ proconfig.footer_txt }}
          </label>
        </div>
        <div style="text-align: center; margin-left: 30px">
          <img :src="proconfig.qrcode" style="width: 120px; height: 120px" />
          <div style="margin-top: 10px">主场服务小程序</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mbrInfo from '@/components/mbrInfo.vue'
export default {
  name: 'Nav',
  components: { mbrInfo },
  data() {
    return {
      currentPath: '/home'
    }
  },
  computed: {
    proconfig() {
      return this.$store.state.exhibition.proconfig
    }
  },
  /*************  ✨ Codeium Command ⭐  *************/
  /**
   * @description: mounted, set default selected nav item
   */
  /******  e23ce8d2-dd7a-4766-b932-947dcb0e1c2f  *******/
  mounted() {
    const path = this.$route.path
    if (path == '/mbr') {
      this.currentPath = '/mbr'
    } else if (path == '/help') {
      this.currentPath = '/help'
    } else if (path.includes('/order')) {
      if (path.includes('boothOrder')) {
        this.currentPath = '/order/boothOrder'
      } else if (path.includes('utilities')) {
        this.currentPath = '/order/leaseOrder/utilities'
      }
    } else {
      this.currentPath = '/home'
    }
  },
  watch: {
    $route(to) {
      const path = to.path
      if (path == '/mbr') {
        this.currentPath = '/mbr'
      } else if (path == '/help') {
        this.currentPath = '/help'
      } else if (path.includes('/order')) {
        if (path.includes('boothOrder')) {
          this.currentPath = '/order/boothOrder'
        } else if (path.includes('utilities')) {
          this.currentPath = '/order/leaseOrder/utilities'
        }
      } else {
        this.currentPath = '/home'
      }
    }
  },
  methods: {
    handleClickHelp() {
      window.open(this.$env.VUE_APP_SUPPORT_CENTER_ADDRESS, '_blank')
      this.currentPath = this.$route.path
      return false
    },
    handleSelect(key) {
      if (key === null || key == this.$route.path) return

      console.log('clickPath', key)
      this.$router.push(key)
    }
  }
}
</script>
<style scoped>
.container {
  min-height: 100vh;
  position: relative;
  box-sizing: border-box;
  overflow: hidden;
  padding-bottom: 210px;
  min-width: 1100px;
}
.nav-page {
  min-height: calc(100vh - 61px - 210px);
  overflow: hidden;
  display: grid;
  grid-template-rows: 1fr;
}
.header {
  width: 100%;
  background-color: white;
  color: #fff;
  height: 61px;
  box-sizing: border-box;
  border-bottom: solid 1px #e6e6e6;
}
.header-main {
  width: 1100px;
  margin: 0 auto;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  height: 60px;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}
.logo {
  margin-right: auto !important;
}

.index_logo {
  max-width: 500px;
}
.index_logo img {
  height: 56px;
}
::v-deep .header .el-menu {
  width: 1100px;
  margin: 0 auto;
  display: flex;
  justify-content: flex-end;
}
::v-deep .header .el-menu.el-menu--horizontal {
  box-sizing: border-box;
}
::v-deep .header .el-menu-item:hover {
  background-color: #f4f4f4 !important;
}
::v-deep .header .el-submenu:hover {
  background-color: #f4f4f4 !important;
}
::v-deep .header .el-menu-item.is-active {
  background-color: #f4f4f4 !important;
}

.logo:hover {
  background-color: white !important;
}

.wrapper-back {
  width: 100%;
  background-color: #00a0e9;
  color: #fff;
  position: absolute;
  bottom: 0;
  left: 0;
}

.bottom-wrapper {
  width: 1100px;
  margin: 0 auto;
  color: white;
  padding: 29px 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.copy-text {
  text-align: center;
}
a {
  color: white;
  text-decoration: none;
  background-color: transparent;
  outline: none;
  cursor: pointer;
  -webkit-transition: color 0.3s;
  transition: color 0.3s;
  -webkit-text-decoration-skip: objects;
}
</style>
